import { Component, OnInit, OnDestroy } from '@angular/core';
import { BaseComponent } from '../pages/base.component';
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-rde-dashboard',
  templateUrl: './rde-dashboard.component.html',
  styleUrls: ['./rde-dashboard.component.css']
})
export class RdeDashboardComponent extends BaseComponent implements OnInit {


  countyAndRegionList: any;
  regionGradeList: any;
  selectedRegionId: any;
  schoolLevelId: any;
  selectedCountyId: any;
  regionGeoList: any;
  dashboardDetails: any;
  topCounties: any[] = [];
  educationLevels: any[] = [];
  radius = 50;
  circumference = 2 * Math.PI * this.radius;
  publicDashArray: string = '';
  privateDashArray: string = '';
  privateDashOffset: number = 0;


  constructor(
    protected CommonService: CommonService,
    protected toastr: ToastrService,
    private router: Router,
    private active: ActivatedRoute
  ) {
    super(CommonService, toastr);

  }

  ngOnInit() {
    this.selectedRegionId = localStorage.getItem("region_id");
    this.schoolLevelId = localStorage.getItem("schoolLevelID");
    this.getcountyandRegion();
    this.getRegionGradeList();
    this.getDashboardGeoList();
    this.LoadDBDitails();
  }



  getcountyandRegion() {
    this.countyAndRegionList = [];
    this.activeSpinner();
    this.CommonService.postCall(`Dashboard/LoadRegionCountiesList`, { "REGION_ID": this.selectedRegionId }).subscribe(
      (res: any) => {
        this.countyAndRegionList = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      }
    );
  }
  getRegionGradeList() {
    this.regionGradeList = [];
    this.activeSpinner();
    this.CommonService.postCall(`Dashboard/LoadRegionDashboardGradeList`, { "REGION_ID": this.selectedRegionId, "SCHOOLLEVEL": this.schoolLevelId }).subscribe(
      (res: any) => {
        this.regionGradeList = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      }
    );
  }

  getDashboardGeoList() {
    this.regionGeoList = [];
    this.activeSpinner();
    this.CommonService.postCall(`Dashboard/LoadDashboardGeoList`, { "REGION_ID": this.selectedRegionId, "SCHOOLLEVEL": this.schoolLevelId, "COUNTIE_ID": this.selectedCountyId }).subscribe(
      (res: any) => {
        this.regionGeoList = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      }
    );
  }

  // LoadDBDitails() {
  //   const userData = JSON.parse(sessionStorage.getItem("userData") || '{}');;
  //   this.dashboardDetails = {};
  //   let payLoad = {
  //     v_tnt_code: localStorage.getItem("TenantCode"),
  //     v_county_id: userData?.county_id,
  //     v_sub_county_id: userData?.subcounty_id,
  //     v_role_id: localStorage.getItem("RoleId"),
  //     v_schoollevel: localStorage.getItem("schoolLevelID"),
  //     v_region_id: localStorage.getItem("region_id")
  //   };
  //   this.CommonService.postCall(`Dashboard/LoadCdeScdeAdminDashboard`, payLoad).subscribe((res: any) => {
  //     this.dashboardDetails = res;
  //   });
  // }



  // Class variables


  LoadDBDitails() {
    const userData = JSON.parse(sessionStorage.getItem("userData") || '{}');

    let payLoad = {
      v_tnt_code: localStorage.getItem("TenantCode"),
      v_county_id: userData?.county_id,
      v_sub_county_id: userData?.subcounty_id,
      v_role_id: localStorage.getItem("RoleId"),
      v_schoollevel: localStorage.getItem("schoolLevelID"),
      v_region_id: localStorage.getItem("region_id")
    };

    this.CommonService.postCall(
      `Dashboard/LoadCdeScdeAdminDashboard`,
      payLoad
    ).subscribe((res: any) => {

      this.dashboardDetails = res;

      // Calculate donut chart
      this.calculateDonutChart();

      // TOP COUNTIES DISTRIBUTION
      const counties = res?.TOP_COUNTIES_DISTRIBUTION || [];

      const maxTotal = Math.max(
        ...counties.map((item: any) => item.total),
        0
      );

      this.topCounties = counties.map((item: any) => ({
        ...item,
        percentage: maxTotal > 0
          ? (item.total / maxTotal) * 100
          : 0
      }));

      // EDUCATION LEVEL DISTRIBUTION
      const education = res?.EDUCATION_LEVEL_DISTRIBUTION || [];

      const maxEducation = Math.max(
        ...education.map((item: any) => item.total),
        0
      );

      this.educationLevels = education.map((item: any) => ({
        ...item,
        percentage: maxEducation > 0
          ? (item.total / maxEducation) * 100
          : 0
      }));
    });
  }

  calculateDonutChart() {

    const publicCount =
      Number(this.dashboardDetails?.INSTITUTIONAL_BREAKDOWN?.reject || 0);

    const privateCount =
      Number(this.dashboardDetails?.INSTITUTIONAL_BREAKDOWN?.pending || 0);

    const total = publicCount + privateCount;

    if (!total) {
      this.publicDashArray = `0 ${this.circumference}`;
      this.privateDashArray = `0 ${this.circumference}`;
      this.privateDashOffset = 0;
      return;
    }

    const publicLength =
      (publicCount / total) * this.circumference;

    const privateLength =
      (privateCount / total) * this.circumference;

    this.publicDashArray =
      `${publicLength} ${this.circumference}`;

    this.privateDashArray =
      `${privateLength} ${this.circumference}`;

    this.privateDashOffset = -publicLength;
  }
}